/* MH injected language/currency switcher (generic wheel, 2026-09-01) */
(function () {
  if (window.__xSwitch) return; window.__xSwitch = 1;
  var CFG = {"langs": [["en", "English"], ["de", "Deutsch"], ["fr", "Français"], ["es", "Español"], ["it", "Italiano"], ["nl", "Nederlands"], ["pt-PT", "Português"], ["sv", "Svenska"], ["pl", "Polski"], ["ar", "العربية"]], "countries": [["US", "United States", "USD"], ["DE", "Germany", "EUR"], ["FR", "France", "EUR"], ["ES", "Spain", "EUR"], ["IT", "Italy", "EUR"], ["NL", "Netherlands", "EUR"], ["PT", "Portugal", "EUR"], ["GB", "United Kingdom", "GBP"], ["CH", "Switzerland", "CHF"], ["SE", "Sweden", "SEK"], ["PL", "Poland", "PLN"], ["CA", "Canada", "CAD"], ["AU", "Australia", "AUD"], ["SA", "Saudi Arabia", "SAR"], ["AE", "United Arab Emirates", "AED"]]};
  var CUR = window.__xL || document.documentElement.getAttribute('lang') || 'en';
  var CTY = window.__xC || 'US';
  /* ---- href prefix layer v3 (2026-09-04, 全店统一轮子) ----
   作用:在本地化路径(/it/、/de-ch/ …)下,把写死的站内链接补上当前语言前缀,点击不丢语言。
   v3 相对 v2:① 绝对链接(https://本站域名/collections/x,带不带 www 都算)也补前缀 ② 永不重复加前缀(按 Shopify.routes.root 判重 + 任何 xx / xx-yy 开头都视为已带语言)
   ③ 页面加载后再补两次(App 晚渲染的菜单)④ 点击时兜底。root 只信 Shopify.routes.root,不猜。 */
(function () {
  if (window.__xHrefFix3) return; window.__xHrefFix3 = 1;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (!ROOT || ROOT === '/') return;
  var P = ROOT.replace(/\/+$/, '');
  var HOST = location.host.toLowerCase().replace(/^www\./, '');
  var SKIP = /^\/(a|cdn|admin|apps|tools|localization|checkout|gift_cards|wpm@|\d+)(\/|$)/;
  function pref(h) {
    if (!h || h.charAt(0) !== '/' || h.charAt(1) === '/') return h;
    var path = h.split(/[?#]/)[0];
    if (SKIP.test(path)) return h;
    if (h === P || h.indexOf(P + '/') === 0 || h.indexOf(P + '?') === 0 || h.indexOf(P + '#') === 0) return h;
    var seg = path.split('/')[1] || '';
    if (/^[a-z]{2}(-[a-z]{2})?$/i.test(seg)) return h;
    return P + h;
  }
  function fix(a) {
    var h = a.getAttribute('href'); if (!h) return;
    if (/^(#|mailto:|tel:|sms:|javascript:)/i.test(h)) return;
    var m = h.match(/^(?:https?:)?\/\/([^\/?#]+)(.*)$/i);
    if (m) {
      if (m[1].toLowerCase().replace(/^www\./, '') !== HOST) return;
      var rest = m[2] || '/'; if (rest.charAt(0) !== '/') rest = '/' + rest;
      var n = pref(rest); if (n !== rest) a.setAttribute('href', n);
      return;
    }
    if (h.charAt(0) !== '/') return;
    var n2 = pref(h); if (n2 !== h) a.setAttribute('href', n2);
  }
  function fixAll() { var as = document.querySelectorAll('a[href]'); for (var i = 0; i < as.length; i++) fix(as[i]); }
  if (document.readyState !== 'loading') fixAll(); else document.addEventListener('DOMContentLoaded', fixAll);
  window.addEventListener('load', function () { fixAll(); setTimeout(fixAll, 1500); setTimeout(fixAll, 4000); });
  document.addEventListener('click', function (e) { var a = e.target && e.target.closest && e.target.closest('a[href]'); if (a) fix(a); }, true);
})();
  /* ---- native localization submit ---- */
  function go(loc, cty) {
    var pn = document.getElementById('xSwitchPanel'); if (pn) { pn.hidden = true; }
    if (!document.getElementById('xSwitchBusy')) {
      var bz = document.createElement('div'); bz.id = 'xSwitchBusy';
      bz.style.cssText = 'position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:2147483600;background:#1c1c1c;color:#fff;padding:8px 18px;border-radius:999px;font:13px/1 sans-serif;box-shadow:0 6px 20px rgba(0,0,0,.25);';
      bz.textContent = '···'; document.body.appendChild(bz);
      var bn = 0; setInterval(function () { bn = (bn + 1) % 4; bz.textContent = '·'.repeat(bn + 1); }, 350);
    }
    var rt = location.pathname + location.search;
    var RT0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (RT0 !== '/') { var RP2 = RT0.replace(/\/$/, ''); if (rt === RP2) rt = '/'; else if (rt.indexOf(RP2 + '/') === 0 || rt.indexOf(RP2 + '?') === 0) rt = rt.slice(RP2.length); }
    var f = document.createElement('form');
    f.method = 'POST'; f.action = '/localization'; f.style.display = 'none';
    var d = { form_type: 'localization', utf8: '✓', _method: 'put', return_to: rt || '/', locale_code: loc || CUR, country_code: cty || CTY };
    for (var k in d) { var i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = d[k]; f.appendChild(i); }
    document.body.appendChild(f); f.submit();
  }
  /* ---- UI ---- */
  function build() {
    if (document.getElementById('xSwitchPill')) return;
    var curCur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var pill = document.createElement('button');
    pill.id = 'xSwitchPill'; pill.type = 'button';
    pill.innerHTML = '🌐 <b style="font-weight:600">' + CUR.toUpperCase().slice(0, 2) + '</b>' + (curCur ? ' · ' + curCur : '');
    pill.style.cssText = 'display:inline-flex;align-items:center;gap:4px;padding:6px 12px;border:1px solid currentColor;border-radius:999px;background:transparent;color:inherit;font:inherit;font-size:12px;letter-spacing:.04em;cursor:pointer;margin:0 10px;line-height:1;vertical-align:middle;';
    var panel = document.createElement('div');
    panel.id = 'xSwitchPanel'; panel.hidden = true;
    panel.style.cssText = 'position:fixed;z-index:2147483000;background:#fff;color:#222;border:1px solid #ddd;border-radius:10px;box-shadow:0 12px 40px rgba(0,0,0,.16);padding:14px 16px;display:flex;gap:18px;font-size:13px;max-height:70vh;overflow:auto;min-width:320px;';
    function col(title, rows, attr) {
      var c = document.createElement('div');
      c.innerHTML = '<div style="font-size:10.5px;letter-spacing:.12em;text-transform:uppercase;opacity:.55;margin-bottom:8px;">' + title + '</div>';
      rows.forEach(function (r) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute(attr, r[0]);
        b.textContent = r[1] + (r[2] ? ' · ' + r[2] : '');
        var active = (attr === 'data-xl' ? r[0] === CUR : r[0] === CTY);
        b.style.cssText = 'display:block;width:100%;text-align:left;background:none;border:none;cursor:pointer;padding:5px 6px;border-radius:6px;font:inherit;font-size:13px;color:#222;' + (active ? 'font-weight:700;background:#f2efe9;' : '');
        b.onmouseenter = function () { b.style.background = '#f5f5f2'; };
        b.onmouseleave = function () { b.style.background = active ? '#f2efe9' : 'none'; };
        c.appendChild(b);
      });
      return c;
    }
    panel.appendChild(col('Language', CFG.langs, 'data-xl'));
    panel.appendChild(col('Country / Currency', CFG.countries, 'data-xc'));
    document.body.appendChild(panel);
    var anchor = null;
    var accSel = ['header a[href*="/account"]', '.header a[href*="/account"]', '#shopify-section-header a[href*="/account"]', 'a[href*="/account"]'];
    for (var i = 0; i < accSel.length && !anchor; i++) anchor = document.querySelector(accSel[i]);
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(pill, anchor);
    } else {
      pill.style.cssText += 'position:fixed;bottom:18px;left:16px;z-index:2147483000;background:#fff;color:#222;border:1px solid #ccc;box-shadow:0 6px 24px rgba(0,0,0,.18);';
      document.body.appendChild(pill);
    }
    function place() {
      var r = pill.getBoundingClientRect();
      var openUp = r.bottom > window.innerHeight * 0.6;
      panel.style.left = Math.max(8, Math.min(r.left, window.innerWidth - panel.offsetWidth - 8)) + 'px';
      if (openUp) { panel.style.bottom = (window.innerHeight - r.top + 8) + 'px'; panel.style.top = 'auto'; }
      else { panel.style.top = (r.bottom + 8) + 'px'; panel.style.bottom = 'auto'; }
    }
    pill.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      panel.hidden = !panel.hidden;
      if (!panel.hidden) place();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#xSwitchPanel') && !e.target.closest('#xSwitchPill')) panel.hidden = true;
    });
    panel.addEventListener('click', function (e) {
      var l = e.target.closest('[data-xl]');
      if (l) { go(l.getAttribute('data-xl'), CTY); return; }
      var c = e.target.closest('[data-xc]');
      if (c) { go(CUR, c.getAttribute('data-xc')); }
    });
  }
  if (document.readyState !== 'loading') build(); else document.addEventListener('DOMContentLoaded', build);
})();

/* ---- chrome + A+ dictionary loader (generic wheel) ---- */
(function () {
  if (window.__xDict) return; window.__xDict = 1;
  var CUR = window.__xL || document.documentElement.getAttribute('lang') || 'en';
  if (CUR === 'en') return;
  var sc = document.querySelector('script[src*="-switcher"]');
  var base = sc ? sc.src.split(/[a-z]{2}-switcher/)[0] : '';
  if (!base) return;
  var c = 'mh';
  function apply(map) {
    if (!map) return;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue, tr = t.trim();
      if (!tr) continue;
      var hit = map[tr];
      if (hit) n.nodeValue = t.replace(tr, hit);
    }
    document.querySelectorAll('input[placeholder]').forEach(function (i) {
      var hit = map[i.placeholder.trim()];
      if (hit) i.placeholder = hit;
    });
  }
  function watch(map) {
    if (!window.MutationObserver) return;
    var t = null;
    var mo = new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; apply(map); }, 250);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
  function load(u) { fetch(u).then(function (r) { return r.ok ? r.json() : null; }).then(function (map) { if (!map) return; apply(map); window.addEventListener('load', function () { apply(map); watch(map); }); }).catch(function () {}); }
  function go() {
    load(base + c + '-i18n-chrome-' + CUR + '.json');
    if (window.__xTpl !== undefined && window.__xTpl !== null) load(base + c + '-i18n-tpl-' + (window.__xTpl || 'default') + '-' + CUR + '.json');
  }
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
})();
